// Components/ReusableDrawer.js
import React from "react";
import { Box, Drawer, IconButton, Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import MuiTypographyMandatory from "./Custom/MuiTypographyMandatory";

const ReusableDrawer = ({
  open,
  onClose,
  title,
  children,
  onSubmit,
  showFooter = true,
  submitText = "Submit",
}) => {
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: { xs: "100%", sm: 500, md: 540 },
          maxWidth: "100%",
        },
      }}
    >
      <Box
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          bgcolor: "#FFF",
        }}
      >
        {/* Header */}
        <Box
          sx={{
            position: "sticky",
            top: 0,
            zIndex: 10,
            bgcolor: "#FFF",
            borderBottom: "1px solid #e0e0e0",
            px: 3,
            py: 2,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <MuiTypographyMandatory label={title} required={false} variant="h1"  sx={{fontSize:'25px'}}/>
          <Box>
            <IconButton onClick={onClose}>
                <CloseIcon sx={{ border: "2px solid #354052", borderRadius: "50%" }} />
            </IconButton>
          </Box>
        </Box>

        <Box sx={{ flexGrow: 1, overflowY: "auto" }}>{children}</Box>

        {showFooter && (
          <Box
            sx={{
              position: "sticky",
              bottom: 0,
              zIndex: 10,
              bgcolor: "#FFF",
              borderTop: "1px solid #B5B5B5",
              px: 3,
              py: 2,
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
            }}
          >
            <Button variant="outlined" color="primary" onClick={onClose}>
              Cancel
            </Button>
            <Button variant="contained" color="primary" onClick={onSubmit}>
              {submitText}
            </Button>
          </Box>
        )}
      </Box>
    </Drawer>
  );
};

export default ReusableDrawer;
